import React from 'react';
import '../../style/loader.css';

const LoaderComponent = ({ inline }) => {
    return (
        <div className={`loader-wrapper ${inline ? 'inline' : 'page'}`}>
            <div className={`loader-ring ${inline ? 'inline' : ''}`}>
                <div className="loader-glow" />
                {!inline && <div className="loader-text">Loading...</div>}
            </div>
        </div>
    );
};

export default LoaderComponent;